<template lang="pug">
  div(class="block")
    h2(class="title", :active="show")
      | {{title}}
      div(class="flip", :active="show")
</template>
<script>
  import EventListener from 'modules/mixins/eventListener';

  export default {
    mixins: [EventListener],
    props: {
      title: { type: String, required: true },
    },
    data() {
      return {
        show: false,
      };
    },
    mounted() {
      this.$listen(window, 'scroll', () => {
        const { innerHeight } = window;
        const { top } = this.$el.getBoundingClientRect();
        if (innerHeight > top + 50) {
          this.show = true;
        }
      });
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .block {
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
    @include mq('sm') {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
  .title {
    position: relative;
    font-size: 3.2rem;
    font-weight: 300;
    color: $c-pink-dark;
    background-color: $c-khaki-light;
    padding: 0.7em 0.3em;
    transform: scale(0);
    transition: transform 0.3s;
    &[active] {
      transform: scale(1);
    }
    @include mq('sm') {
      font-size: 4.4rem;
    }
    @include mq('xs') {
      font-size: 2.6rem;
    }
  }
  .flip {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 10px solid $c-khaki-dark;
    border-left: 10px solid $c-khaki-dark;
    border-right: 10px solid $c-khaki;
    border-bottom: 10px solid $c-khaki;
    transform: scale(0);
    transform-origin: right bottom;
    transition: transform 0.3s 0.6s;
    &[active] {
      transform: scale(1);
    }
    @include mq('sm') {
      border-width: 17px;
    }
  }
</style>
